import { Icon } from 'components/Icon'

export const Gorgias = () => {
  return (
    <li>
      <a onClick={window.GorgiasChat.open} aria-label="open chat" rel="noreferrer" href="#">
        <Icon size={{ '@initial': '4', '@bp1': '3' }} name={'chat-line'} />
        Chat
      </a>
    </li>
  )
}
